import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { enumsStateSelector } from '~/selectors';

import { AllEnums, Enum, EnumListKey } from './types';

export const useAllEnums = (): {
  allEnums: AllEnums;
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
  getEnums: (enumListKey: EnumListKey) => Enum[];
} => {
  const enumsStore = useSelector((state: StoreState) => {
    return enumsStateSelector(state);
  });
  const { allEnums } = enumsStore;

  const getEnums = useCallback(
    (enumListKey: EnumListKey): Enum[] => {
      return allEnums[enumListKey] || [];
    },
    [allEnums],
  );

  return {
    ...enumsStore,
    getEnums,
  };
};
